
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_368_32080)"}},[_c('path',{attrs:{"d":"M11.053.509a1.311 1.311 0 00-1.856 0l-.706.703 2.295 2.294.705-.705a1.311 1.311 0 000-1.856l-.438-.436zM4.041 5.665a1.295 1.295 0 00-.317.513L3.03 8.26a.565.565 0 00.713.713l2.081-.694c.192-.063.368-.173.514-.316l3.92-3.924-2.296-2.297L4.04 5.665zM2.25 1.5A2.25 2.25 0 000 3.75v6A2.25 2.25 0 002.25 12h6a2.25 2.25 0 002.25-2.25V7.5a.75.75 0 10-1.5 0v2.25a.75.75 0 01-.75.75h-6a.75.75 0 01-.75-.75v-6A.75.75 0 012.25 3H4.5a.75.75 0 100-1.5H2.25z","fill":"#0D69D5"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_368_32080"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h12v12H0z"}})])])])
          )
        }
      }
    